(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Transaction.Capture.Households",
                {
                    url: "/Household",
                    component: "captureHouseholds",
                    resolve: {
                        prevStage: [
                            "transaction", "transactionApi", "_", function (transaction, transactionApi, _) {
                                var currIndex = _.findIndex(transaction.CapturePoints,
                                    function (capturePoint) {
                                        return capturePoint === "Households";
                                    });

                                if (currIndex === 0) {
                                    return transactionApi.getDisclosures(transaction.Id).then(function (disclosures) {
                                        return disclosures.length === 0 ? null : "Transaction.Disclose";
                                    });
                                } else return "Transaction.Capture." + transaction.CapturePoints[currIndex - 1];
                            }
                        ],
                        nextStage: [
                            "transaction", "_", function (transaction, _) {
                                var currIndex = _.findIndex(transaction.CapturePoints,
                                    function (capturePoint) {
                                        return capturePoint === "Households";
                                    });

                                return currIndex === transaction.CapturePoints.length - 1
                                    ? "Transaction.Determine.ProductChoice"
                                    : "Transaction.Capture." + transaction.CapturePoints[currIndex + 1];
                            }
                        ],
                        prefixes: [
                            "prefixes", function (prefixes) {
                                return prefixes;
                            }
                        ],
                        suffixes: [
                            "suffixes", function (suffixes) {
                                return suffixes;
                            }
                        ],
                        states: [
                            "states", function (states) {
                                return states;
                            }
                        ],
                        genders: [
                            "genders", function (genders) {
                                return genders;
                            }
                        ],
                        relationTypes: [
                            "relationTypes", function (relationTypes) {
                                return relationTypes;
                            }
                        ],
                        transactionRelationships: [
                            "transaction", "transactionRelationshipApi", function (transaction, transactionRelationshipApi) {
                                return transactionRelationshipApi.getTransactionRelationships(transaction.Id);
                            }
                        ]
                    },
                    onEnter: ["transactionApi", "transaction", function (transactionApi, transaction) {
                        transaction.LastTransactionStage = "Households";
                        transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                    }]
                });
        }
    ]);

    app.component("captureHouseholds",
        {
            templateUrl: "/App/Transaction/Capture/Households/template.html",
            controller: captureHouseholdsController,
            bindings: {
                transaction: "<",
                prevStage: "<",
                nextStage: "<",
                prefixes: "<",
                suffixes: "<",
                states: "<",
                genders: "<",
                relationTypes: "<",
                transactionRelationships: "<"
            }
        });

    captureHouseholdsController.$inject = ["$scope", "$state", "_", "$q", "moment", "$mdDialog", "clientApi", "personApi", "transactionRelationshipApi"];
    function captureHouseholdsController($scope, $state, _, $q, moment, $mdDialog, clientApi, personApi, transactionRelationshipApi) {
        $scope.$parent.$ctrl.getCurrentStage($state);
        var $ctrl = this;
        
        $ctrl.ui = { addingClient: false }
        ng.extend($ctrl,
            {
                maxDate: new Date(),
                remove: remove,
                update: update,
                setDob: setDob,
                getSsn: getSsn,
                addClient: addClient,
                addByEnter: addByEnter,
                updateSsn: updateSsn,
                searchClients: searchClients
            });

        function remove(client) {
            if ($ctrl.selectedClient.Id === client.Id)
                $ctrl.selectedClient = $ctrl.mainClient;

            $ctrl.transactionRelationships = _.filter($ctrl.transactionRelationships,
                function (item) {
                    return item.Id !== client.Id;
                });

            transactionRelationshipApi.delete($ctrl.transaction.Id, client.Id);
        };

        function update(client) {
            personApi.update(client.Person).then(function () {
                transactionRelationshipApi.update($ctrl.transaction.Id, client.Id, client);
            });
        };

        function getSsn(client) {
            return personApi.getSsn(client.Person.Id).then(function (ssn) { client.Person.Ssn = ssn.Ssn; });
        };

        function addClient() {
            $ctrl.ui.addingClient = true;
            var promise = null;
            var clientId = null;

            if ($ctrl.searchClient) {
                if ($ctrl.searchClient.Type === "NewClient") {
                    var client = {
                        Person: {
                            FirstName: $ctrl.searchClient.Name.substring(0, $ctrl.searchClient.Name.indexOf(" ")),
                            MiddleName: $ctrl.searchClient.Name.substring($ctrl.searchClient.Name.indexOf(" ") + 1, $ctrl.searchClient.Name.lastIndexOf(" ")),
                            LastName: $ctrl.searchClient.Name.substring($ctrl.searchClient.Name.lastIndexOf(" ") + 1, $ctrl.searchClient.Name.length)
                        }
                    }

                    promise = clientApi.add(client).then(function (response) {
                        return clientId = response.Id;
                    });
                }

                $q.when(promise).then(function () {
                    var relationship = {
                        TransactionId: $ctrl.transaction.Id,
                        RelatedClientId: clientId || $ctrl.searchClient.Id,
                        Type: "Other"
                    };
                    return transactionRelationshipApi.add($ctrl.transaction.Id, relationship).then(function (response) {
                        return transactionRelationshipApi.get($ctrl.transaction.Id, response.Id).then(function (response) {
                            relationship = response;
                            relationship.Person.Dob = relationship.Person.Dob === null ? null : new Date(relationship.Person.Dob);
                            $ctrl.transactionRelationships.push(relationship);
                            $ctrl.selectedClient = relationship;
                            $ctrl.searchClient = null;
                            $ctrl.searchText = "";
                            $ctrl.ui.addingClient = false;
                        });
                    });
                });
            }
        };

        function updateSsn(client) {
            if (!client.Person.Ssn) {
                return personApi.removeSsn(client.Person.Id)
                    .then(function () {
                        return client.Person.Ssn = null;
                    });
            }
            client.Person.Ssn = client.Person.Ssn.replace(/[^0-9]/g, "");
            if (client.Person.Ssn.length !== 9) {
                return;
            }
            return personApi.updateSsn(client.Person.Id, { Ssn: client.Person.Ssn })
                .then(function () { },
                function (error) {
                    if (error.status !== 400) {
                        return error;
                    }
                    return;
                });
        };

        function searchClients(term) {
            return clientApi.searchAgentClients($ctrl.transaction.PrimaryAgentId, term).then(function (response) {
                response = _.reject(response,
                    function (row) {
                        return _.find($ctrl.transactionRelationships, function (relationship) {
                            return relationship.Person.Id === row.Id;
                        });
                    });

                ng.forEach(response,
                    function (row) {
                        row.Term = (row.Client.Person.FirstName || "") +
                            " " +
                            (row.Client.Person.LastName || "") +
                            (row.Client.Person.LastFourSsn ? " (" + row.Client.Person.LastFourSsn + ")" : "");
                    });
                response.push({ Term: "Select to add client", Name: $ctrl.searchText, Type: "NewClient" });
                return response;
            });
        };

        function addByEnter() {
            if ($ctrl.searchText) {
                $ctrl.searchClient = { Name: $ctrl.searchText, Type: "NewClient" }
                addClient();
            }
        }
        function setDob(client) {
            if (client.Person.Dob) {
                client.Person.Dob = new Date(client.Person.Dob);
                var dob = moment(client.Person.Dob);

                client.Person.Age = moment().diff(dob, "years");
            }
        }

        this.$onInit = function() {
            $ctrl.mainClient = _.find($ctrl.transactionRelationships,
                function (relationship) {
                    return relationship.Type === "Client";
                });

            $ctrl.setDob($ctrl.mainClient);
            $ctrl.selectedClient = $ctrl.mainClient;
        };
    };

})(window.app, window.angular); //jshint ignore:line